import React from 'react';

const SearchBar = ({ value, onChange, placeholder = "Search...", className = "search-container" }) => {
  return (
    <div className={className}>
      <input type="text" className="search-input" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} style={{ fontSize: '14px', padding: '8px 12px', borderRadius: '6px' }} />
      {value && (
        <button className="ankr-search-clear" onClick={() => onChange('')} style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', fontSize: '16px', color: '#666', cursor: 'pointer', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>×</button>
      )}
    </div>
  );
};

export default SearchBar;